import { render, staticRenderFns } from "./mvp-login.vue?vue&type=template&id=df1e0976&scoped=true&"
import script from "./mvp-login.vue?vue&type=script&lang=js&"
export * from "./mvp-login.vue?vue&type=script&lang=js&"
import style0 from "./mvp-login.vue?vue&type=style&index=0&id=df1e0976&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e0976",
  null
  
)

export default component.exports